import { useContext } from "react"
import { RouteContext } from "./RouteContext"

export const useRoute = () => {
  const values = useContext(RouteContext)
  return values
}
